<template>
  <apexchart type=bar
             v-bind:series="day_of_week"
             v-bind:options="chart_options"
             width="99%" height=250 />
</template>

<script>
import 'array-flat-polyfill';
import util from '../../util'

export default {
  name: 'AccountDetailsDayOfWeek',

  props : {
    txs: Array
  },

  computed : {
    day_of_week : function(){
      var dow = [];
      for(var d = 0; d < 7; d += 1)
        dow.push(0);

      this.txs.flat().forEach(function(tx){
        var day = new Date(util.ledger_time_to_unix(tx["tx"]["date"])).getDay();
        dow[day] += 1;
      });

      return [{data:dow, name : 'Number of Txs'}];
    },

    chart_options : function(){
      return {'labels' : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
              'tooltip' : {enabled : false}, dataLabels : {enabled : false}}
    }
  }
}
</script>

<style scoped>
</style>
